import { instance } from '~/utils/api/api';
import dayjs, { Dayjs } from 'dayjs';
import { BUTTON_STYLES, Button, RadioInput } from '~/ui';
import styles from './XlsReportAccommodationPopoverContent.module.scss';
import { useContext, useState } from 'react';
import { PopoverContext } from '~/components/XlsUploadFilePopover/XlsUploadFilePopover';
import { downloadFile } from '~/utils/downloadFile';
import { useTranslation } from 'react-i18next';
import { CustomDatePicker } from '~/components/Shared/CustomDatePicker/CustomDatePicker';

const XlsReportAccommodationPopoverContent = () => {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [typeReport, setTypeReport] = useState<string>('1');
  const { setIsPopoverVisible } = useContext(PopoverContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation();

  const onClosePopup = () => {
    setStartDate(null);
    setEndDate(null);
    setIsPopoverVisible(false);
  };

  const downloadFileReport = async () => {
    setIsLoading(true);
    let typeReportPath: string;
    let typeReportName: string;

    if (typeReport === '1') {
      typeReportPath = 'analytics-accommodation-all';
      typeReportName = 'analytics-accommodation';
    } else if (typeReport === '2') {
      typeReportPath = 'analytics-accommodation-statistics';
      typeReportName = 'analytics-accommodation-details';
    } else {
      return;
    }

    const response = await instance.get(`admin/${typeReportPath}`, {
      params: {
        start_date: startDate
          ?.hour(0)
          .minute(0)
          .second(1)
          .format('YYYY-MM-DD HH:mm:ss'),
        end_date: endDate?.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      },
      responseType: 'blob',
    });

    downloadFile(response.data, 'text/xlsx', `${typeReportName}.xlsx`);
    setIsLoading(false);
  };

  const disabledSendReport = !startDate || !endDate;

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().startOf('day');
  };

  return (
    <div className={styles.formWrapper}>
      <span className={styles.formTitle}>{t('analytics_on_placements')}</span>
      <div className={styles.radioBtnTypeReportWrapper}>
        <RadioInput
          label={t('brief_report')}
          name="type_report"
          value="1"
          onChange={() => setTypeReport('1')}
          checkValue={typeReport}
          disabled={false}
        />
        <RadioInput
          label={t('full_report')}
          name="type_report"
          value="2"
          onChange={() => setTypeReport('2')}
          checkValue={typeReport}
          disabled={false}
        />
      </div>
      <div className={styles.dateWrapper}>
        <div className={styles.labelWrapper}>
          <span className={styles.labelText}>
            {t('date')}
            <span className={styles.labelStar}>*</span>
          </span>
          <CustomDatePicker
            value={[startDate, endDate]}
            showPresets={true}
            disabledDate={disabledDate}
            onChange={(name, value) => {
              if (name === 'start_date') {
                setStartDate(value);
              } else if (name === 'end_date') {
                setEndDate(value);
              }
            }}
          />
        </div>
      </div>
      <div className={styles.btnWrapper}>
        <Button
          onClick={onClosePopup}
          className={styles.contentBtn}
          text={t('cancel')}
          disabled={false}
          buttonStyle={BUTTON_STYLES.EMPTY}
        />
        <Button
          onClick={downloadFileReport}
          type="submit"
          text={t('download_report')}
          className={styles.sendBtn}
          disabled={disabledSendReport || isLoading}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default XlsReportAccommodationPopoverContent;
